import { Header } from "../Forms/SmartForm";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "../Modal/Modal";
import ModalGate from "../ModalGate/ModalGate";

const PdfSubmission = ({article ={}}) => {
    const [displayThankModal, setDisplayThankModal] = useState(false);
    const [relatedOLP, setRelatedOLP] = useState([]);

    const cardListRef = useRef(null);
    const cardListArrowRef = useRef(null);
    const eventListenersAddedRef = useRef(false);

    const handleOpenModal = async () => {
        try {
            const response = await axios.get("/api/pdf-related-olp", {
                params: { articleNo: article.articleNo }
            });
            setRelatedOLP(response.data?.relatedOLP);
        } catch (ignore) {
        }
    };

    const addScrollEventListeners = () => {
        const slider = cardListRef.current;
        const arrow = cardListArrowRef.current;
        const isListening = eventListenersAddedRef.current;

        // check the event listeners have not already been added
        if (!slider || isListening) return;

        // Scrollbars can behave differently across various browsers and devices, here we implementing a custom drag-to-scroll feature
        let isDown = false;
        let startX;
        let scrollLeft;

        const onMouseDown = (e) => {
            isDown = true;
            slider.classList.add("active");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        };

        const onMouseLeave = () => {
            isDown = false;
            slider.classList.remove("active");
        };

        const onMouseUp = () => {
            isDown = false;
            slider.classList.remove("active");
        };

        const cardWidth = slider.querySelector(".pdfRelatedContent .articleTab").offsetWidth;
        const onMouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3;
            slider.scrollLeft = scrollLeft - walk;
        };

        slider.addEventListener("mousedown", onMouseDown);
        slider.addEventListener("mouseleave", onMouseLeave);
        slider.addEventListener("mouseup", onMouseUp);
        slider.addEventListener("mousemove", onMouseMove);

        if (arrow) {
            arrow.addEventListener("click", () => {
                // Smooth scroll to the new position by one card width
                slider.scrollLeft += cardWidth;
            });
        }
        eventListenersAddedRef.current = true;

        // Cleanup function
        return () => {
            slider.removeEventListener("mousedown", onMouseDown);
            slider.removeEventListener("mouseleave", onMouseLeave);
            slider.removeEventListener("mouseup", onMouseUp);
            slider.removeEventListener("mousemove", onMouseMove);

            if (arrow) {
                arrow.removeEventListener("click");
            }
        };
    };

    const decodeSpecialCharacters = (html) => {
        const element = document.createElement("div");
        element.innerHTML = html;
        return element.textContent;
    };

    const onSubmit = async (formValues) => {

        try {
            setDisplayThankModal(true);
            addScrollEventListeners();
            await axios.post(`/api/pdf-generator/${article.articleNo}`, {
                formValues
            });
        }catch (error) {
            //The errors are caught in web server and logged to rollbar
        }

        // Push datalayer event for tracking within Google Analytics (GTM)
        window.dataLayer.push({
            "event": "submitPDFFormSuccess",
            "gtmCustomClick": {
                "eventCategory": "Conversion"
            }
        });
    };
    const handleDataLayer = (articleClicked, index) => {
        if (window.dataLayer) {
            const dataLayer = {
                event: "olp-related-content-click-pdf-modal",
                index: index,
                articleTitle: articleClicked.title,
                sponsoredVendorNos: articleClicked.sponsoredVendorNos.join(","),
                sponsorNames: articleClicked.sponsorNames.join(","),
                clickUrl: articleClicked.absoluteURL,
            };
            window.dataLayer.push(dataLayer);
        }
    };

    const modalHeaderContent = () =>
        <>
            <p className="m-b-0 text-inverted">
                Complete the form below and we will email you a
                PDF version of
            </p>
            <p
                className="text-inverted bold"
                dangerouslySetInnerHTML={{
                    __html: article.articleTitle,
                }}
            ></p>
        </>;

    const renderRelatedArticles = () => {
        if (relatedOLP && relatedOLP.length > 0) {
            return (
                <div className="pdfRelatedContent p-1">
                    <h2>You might also be interested in...</h2>
                    <div className="articleTabList" ref={cardListRef}>
                        {relatedOLP.map((item, index) => {
                            const { articleNo, title, picturetag, fullSlug } = item;
                            const { sourceTagData, imageTagData } = picturetag;
                            return (
                                <div
                                    className="articleTab forMedia"
                                    key={articleNo}
                                >
                                    {picturetag && (
                                        <div className="articleTabImg">
                                            <a
                                                href={fullSlug}
                                                target="_blank"
                                                onClick={() =>
                                                    handleDataLayer(item, index)
                                                }
                                            >
                                                <picture>
                                                    {sourceTagData.map(
                                                        (data, index) => {
                                                            return (
                                                                <source
                                                                    key={index}
                                                                    media={
                                                                        data.media
                                                                    }
                                                                    srcSet={
                                                                        data.srcset
                                                                    }
                                                                    type={
                                                                        data.type
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )}
                                                    <img
                                                        className={
                                                            imageTagData.class
                                                        }
                                                        src={imageTagData.src}
                                                        alt={imageTagData.alt}
                                                        width={400}
                                                        height={280}
                                                        title={
                                                            imageTagData.title
                                                        }
                                                    ></img>
                                                </picture>
                                            </a>
                                        </div>
                                    )}
                                    <div className="articleTabText">
                                        <a
                                            href={fullSlug}
                                            target="_blank"
                                            onClick={() =>
                                                handleDataLayer(item, index)
                                            }
                                        >
                                            <h3 className="max-3-lines">
                                                {decodeSpecialCharacters(title)}
                                            </h3>
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="card-list-arrow" ref={cardListArrowRef}>
                        {">"}
                    </div>
                </div>
            );
        }
        return null;
    };
    const ThankYouModal = () => {
        return (
            <Modal>
                <div
                    className="modal-gate"
                    id="ThankYouModal"
                >
                    <div className="modal-gate-content large m-0">
                        <button
                            className="close-btn corner background-transparent no-border text-white float-right"
                            onClick={() => setDisplayThankModal(false)}
                        >
                            <i className="fas fa-times"/>
                        </button>
                        <Header className="p-v-1 p-h-2 m-b-0 text-center">
                            <h1 className="text-inverted">Thank you!</h1>
                            <p className="text-inverted">
                                We have emailed you a PDF version of the article
                                you requested.
                            </p>
                        </Header>
                        {renderRelatedArticles()}
                        <div className="form-footer background-white text-center p-v-1 p-h-2">
                            <h1>Can't find the email?</h1>
                            <p>Please check your spam or junk folder.</p>
                            <p>
                                You can also add{" "}
                                <a className="email" href={`mailto:info@labmanager.com`}>
                                    info@labmanager.com
                                </a>{" "}
                                to your safe senders list to ensure that you
                                never miss a message from us.
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    const buttonContent = (_, dataAttribute = "") => {
        return (
            <>
                <i
                    className="far fa-file-pdf"
                    aria-hidden="true"
                    data-attribute={dataAttribute}
                />
                <span data-attribute={dataAttribute}>Download PDF</span>
            </>
        );
    };

    return (
        <div id="PdfSubmission">
            {displayThankModal && ThankYouModal()}
            <ModalGate
                onSubmit = {onSubmit}
                dataAttribute = "get-pdf-version"
                modalHeaderContent = {modalHeaderContent}
                buttonContent = {buttonContent}
                handleOpenModal = {handleOpenModal}
                clickOpenModalEventName ="clickOpenPDFModal"
                clickCloseModalEventName ="clickClosePDFModal"
            />
        </div>
    );
};

export default PdfSubmission;
